import { useState } from 'preact/hooks';

export type Serializer<T> = {
  serialize: (v: T) => string,
  deserialize: (s: string) => T,
};

export const simpleSetSerializer = {
  serialize(v: Set<string>) {
    return JSON.stringify(Array.from(v.values()));
  },
  deserialize(s: string): Set<string> {
    return new Set(JSON.parse(s));
  },
};

export function useLocalStorage<T>(key: string, {serialize, deserialize}: Serializer<T>, init: T): [T, (v: T) => void] {
  let stored = init;
  try {
    const fromStorage = window.localStorage.getItem(key);
    stored = fromStorage !== null ? deserialize(fromStorage) : init;
  } catch (e) {
    console.warn("failed to restore from localStorage", e);
  }
  const [data, originalSetter] = useState(stored);

  const proxiedSetter = (newValue: T) => {
    window.localStorage.setItem(key, serialize(newValue));
    originalSetter(newValue);
  };

  return [data, proxiedSetter];
}

export function tinyCommandPolyfill(evt: MouseEvent) {
  if ("command" in HTMLButtonElement.prototype) {
    // Invoker Commands supported natively by browser
    return;
  }

  const command = (evt.target as HTMLElement).attributes.getNamedItem("command")?.textContent;
  const commandFor = (evt.target as HTMLElement).attributes.getNamedItem("commandfor")?.textContent;
  if (command !== undefined && commandFor !== undefined) {
    const commandTarget = document.getElementById(commandFor) as HTMLDialogElement;
    switch (command) {
      case "show-modal":
        commandTarget?.showModal();
        break;
      case "request-close":
          // close enough
          commandTarget?.close();
        break;
    }
  }
}

export function tinyDialogAutoclosePolyfill(evt: MouseEvent) {
  if ("closedBy" in HTMLDialogElement.prototype) {
    // supported natively by browser
    return;
  }

  const dialog = evt.target as HTMLDialogElement;

  if (dialog.localName.toLocaleLowerCase("ASCII") !== "dialog") {
    // event target is not the dialog itself
    return;
  }

  if (evt.layerX < 0
    || evt.layerX > dialog.clientWidth
    || evt.layerY < 0
    || evt.layerY > dialog.clientHeight
  ) {
    dialog.close();
  }
}
